import React from 'react';

import { UploadFileByQrLink } from '@/modules/transaction/components/ReimburseMe/UploadFileQRCode/UploadFileByQrLink';

const UploadFileByQrLinkPage = () => (
  <UploadFileByQrLink />
);

export default UploadFileByQrLinkPage;
